import { summon, AType } from "@silversea-ssc/functional-support"
import { FATAL, MISSING_CRUISE, TRANSIENT } from "../error-codes"

export const FareOptionsErrorCode = summon((F) =>
    F.keysOf({ [MISSING_CRUISE]: null, [FATAL]: null, [TRANSIENT]: null }),
)
export type FareOptionsErrorCode = AType<typeof FareOptionsErrorCode>
